import { isStrictAdmin } from "@/helpers/UserHelpers";
import { selectCurrentUser } from "@/services/slices/authSlice";
import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const DefaultView: FC = () => {
  const navigation = useNavigate();
  const currentUser = useSelector(selectCurrentUser);

  useEffect(() => {
    navigation(isStrictAdmin(currentUser) ? "/admin/dashboard" : "/companies");
  }, [currentUser]);

  return null;
};

export default DefaultView;
